module.exports = __webpack_public_path__ + "static/media/pics14.e1ab3e59.png";